angular.module('b2bLoginApp.services').factory('LoadingInterceptor', ["$q", "Loading", function ($q, Loading) {
    return {
        request: function (config) {
            config.loadingDeferred = config.$promiseTrackerDeferred || [];
            if (config.headers.useTracker === undefined || config.headers.useTracker === true) {
                var deferred = Loading.createPromise();
                config.loadingDeferred.push(deferred);
            }
            return $q.when(config);
        },
        response: function (response) {
            if (response.config && response.config.loadingDeferred) {
                angular.forEach(response.config.loadingDeferred, function (deferred) {
                    deferred.resolve(response);
                });
            }
            return $q.when(response);
        },
        responseError: function (response) {
            if (response.config && response.config.loadingDeferred) {
                angular.forEach(response.config.loadingDeferred, function (deferred) {
                    deferred.reject(response);
                });
            }
            return $q.reject(response);
        }
    };
}]);
